module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img4.d0f3d91f063519befb24d7a2d101dcb5.jpg";